import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import AddressPage from "@/pages/AddressPage";
import TxPage from "@/pages/TxPage";
import BlockPage from "@/pages/BlockPage";
import BlocksPage from "@/pages/BlocksPage";
import TransactionsPage from "@/pages/TransactionsPage";
import TokenPage from "@/pages/TokenPage";
import TokensPage from "@/pages/TokensPage";
import StockTokensPage from "@/pages/StockTokensPage";
import WatchlistPage from "@/pages/WatchlistPage";
import AnalyticsPage from "@/pages/AnalyticsPage";

function App() {
  const [theme, setTheme] = useState(localStorage.getItem("gmscan_theme") || "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("gmscan_theme", theme);
  }, [theme]);

  return (
    <div className="App noise-bg relative">
      <BrowserRouter>
        <Header theme={theme} setTheme={setTheme} />
        <main className="relative z-10 mx-auto max-w-7xl px-4 sm:px-8 pb-16 min-h-[70vh]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/address/:hash" element={<AddressPage />} />
            <Route path="/tx/:hash" element={<TxPage />} />
            <Route path="/block/:id" element={<BlockPage />} />
            <Route path="/blocks" element={<BlocksPage />} />
            <Route path="/txs" element={<TransactionsPage />} />
            <Route path="/token/:address" element={<TokenPage />} />
            <Route path="/tokens" element={<TokensPage />} />
            <Route path="/stocks" element={<StockTokensPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/watchlist" element={<WatchlistPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster theme={theme} position="bottom-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
